<template>
  <!-- 人脸管理-->
  <el-container class="face-verify-management pagination-list">
    <el-main>
      <div class="content">
        <div class="face-verify-search">
          <el-form @submit.native.prevent>
            <el-form-item label="姓名" label-width="50px">
              <el-input v-model="name" clearable placeholder="请输入姓名" @keydown.native.enter="search"></el-input>
            </el-form-item>
            <el-button @click="search" size="mini">查询</el-button>
          </el-form>
        </div>
        <div class="face-verify-table">
          <el-table
            class="table-list"
            v-loading="loading"
            height="100%"
            border
            :data="data"
            highlight-current-row
            :cell-style="{fontSize:'12px'}">
            <el-table-column
              show-overflow-tooltip
              labe="操作"
              align="center"
              width="70px"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="deleteItem(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              v-for="column in columns"
              :label="column.label"
              :key="column.prop"
              :prop="column.prop"
              align="center"
              :width="column.label === '工号' && '100px'"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-footer">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="total, prev, pager, next, sizes"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            background
          >
          </el-pagination>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>

export default {
  name: 'face-verify-management',
  data () {
    return {
      name: '',
      columns: [
        {
          prop: 'id',
          label: '人脸ID'
        }, {
          prop: 'name',
          label: '姓名'
        }, {
          prop: 'jobNum',
          label: '工号'
        }, {
          prop: 'departmentName',
          label: '部门'
        }, {
          prop: 'postName',
          label: '岗位'
        }, {
          prop: 'faceUrl',
          label: '人脸路径'
        }
      ],
      data: [],
      loading: false,
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    search () {
      this.loading = true
      this.$axios.get('/auth-api/users/face', {
        params: {
          filters: {
            keyword: this.name
          },
          index: this.pagination.currentPage,
          size: this.pagination.pageSize
        }
      }).then(res => {
        this.data = res.data.items
        this.pagination.total = res.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    deleteItem (id) {
      this.$confirm(' 是否确认删除该用户人脸数据?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        customClass: 'publishMessageBox'
      }).then(() => {
        this.$axios.delete(`/auth-api/users/face/${id}`).then(res => {
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.search()
          }
        })
      }).catch(() => {})
    },
    // 分页
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.search()
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.search()
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';

  .el-container.face-verify-management {
    font-size: 12px;
    .face-verify-search{
      .el-form {
        height: 37px;
        .el-form-item{
          display: inline-block;
        }
      }
      .el-button{
        margin-left: 20px;
        border: 1px solid #55acf1;
        color: #55acf1;
        padding: 5px;
        vertical-align: middle;
      }
    }
    .face-verify-table{
      height: calc(100% - 45px);
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/users/face-verify-management.vue